import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const hasCreditCardsDefined = createSelector(creditCardsState, (creditCards) => creditCards.data?.length > 0);
